import React, { useState, useContext, useEffect } from 'react';
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';
import Container from '@material-ui/core/Container';
import Button from '@material-ui/core/Button';
import CircularProgress from '@material-ui/core/CircularProgress';
import FormGroup from '@material-ui/core/FormGroup';
import Paper from '@material-ui/core/Paper';

import { Link } from 'react-router-dom';
import { makeStyles } from '@material-ui/core/styles';
import cover from 'src/assets/cover/login_cover.webp';

import { useNavigate } from 'react-router-dom';

import UserContext from '../../context/UserContext';
import axios from 'axios';
import { url } from 'src/api/environment';

import { useSnackbar } from 'notistack';

const useStyles = makeStyles((theme) => ({
  form: {
    display: 'flex',
    flexDireciton: 'column'
  },
  container: {
    height: 'calc(100vh - 4rem)',
    backgroundImage: `url(${cover})`,
    backgroundSize: 'cover',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
  },
  login: {
    backgroundColor: 'white',
    padding: theme.spacing(8),
    [theme.breakpoints.down('xs')]: {
      height: 'calc(100vh - 4rem)',
      borderRadius: 0,
      width: '100%'
    },
  }
}));

const AccountView = () => {
  const classes = useStyles();
  const { enqueueSnackbar } = useSnackbar();
  let navigate = useNavigate();

  const {setUserData} = useContext(UserContext);
  
  const [email, setEmail] = useState();
  const [password, setPassword] = useState();
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if(error !== '') {
      enqueueSnackbar(error, { variant: 'error' });
    }
  }, [error]);

  useEffect(() => {
    if(success !== '') {
      enqueueSnackbar(success, { variant: 'success' });
    }
  }, [success]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const loginUser = { email, password };
      const loginRes = await axios.post(
        `${url}/users/login`, loginUser
      );
      setUserData({
        token: loginRes.data.token,
        user: loginRes.data.user
      });
      
      localStorage.setItem('auth-token', loginRes.data.token);
      setSuccess('Bonjour ' + loginRes.data.user.displayName);
      setSuccess('Connexion réussi !');
      navigate('/my-account');
      setLoading(false);
    }
    catch(error) {
      error.response.data.message && setError(error.response.data.message);
      setLoading(false);
    }
    
  }
  
  return (
    <>
      <Container
        className={classes.container}
        disableGutters
        elevation={0}
        maxWidth="xl"
      >
        <Paper
          className={classes.login}
          elevation={1}
        >
          <Typography
            align="center"
            component="h2"
            variant="h1"
          >
            Connexion
          </Typography>
          <form
            autoComplete="off"
            className={classes.form}
            noValidate
            onSubmit={handleSubmit}
          >
            <FormGroup style={{width: '100%'}}>
              <TextField
                autoComplete="current-password"
                label="Adresse Email"
                onChange={(e) => setEmail(e.target.value)}
                style={{marginBottom: '1rem', width: '100%'}}
                type="email"
                variant="outlined"
              />
              <TextField
                autoComplete="current-password"
                label="Mot de passe"
                onChange={(e) => setPassword(e.target.value)}
                style={{marginBottom: '1rem'}}
                type="password"
                variant="outlined"
              />
              <Button
                color="secondary"
                size="large"
                type="submit"
                variant="contained"
              >
                {!loading ? 
                  'Valider' :
                  <CircularProgress
                    size={30}
                    style={{color: 'white'}}
                  />
                }
              </Button>
            </FormGroup>
          </form>
          <Typography
            style={{marginTop: '1rem'}}
            variant="body1"
          >
            Toujours pas enregistré ? <br />
            <Link to="/register">
              <span style={{color: 'rgb(112, 195, 89)' }}>Créer en un compte maintenant</span>
            </Link>
          </Typography>
          <Typography
            style={{marginTop: '2rem', fontSize: '0.9rem'}}
            variant="subtitle1"
          >
            {error}
          </Typography>
        </Paper>
      </Container>
    </>
  );
}

export default AccountView;
